export {
    Cvss40SupplementalComponent,
    Cvss40SupplementalComponents,
    Cvss40SupplementalComponentNames,
    type Cvss40SupplementalValues,
} from './v4/cvss40-enums';

export enum CvssVersion {
    CVSS20 = 'CVSS2.0',
    CVSS30 = 'CVSS3.0',
    CVSS31 = 'CVSS3.1',
    CVSS40 = 'CVSS4.0',
}
